import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Paragraph, Text } from 'components/core/Typography';
import { Button } from 'components/core/Button';
import { Expand } from 'components/core/Expand';
import Plus from 'components/svg/Plus';
import Minus from 'components/svg/Minus';
import { ChevronDown } from 'components/svg';
import MarkdownWrapper from 'components/search/MarkdownWrapper/MarkdownWrapper';
import FacilityHours from 'components/facility/FacilityHours/FacilityHours';
import FeaturesItem from 'components/core/FeaturesItem/FeaturesItem';

export function FAQItem({
	className,
	question,
	answer,
	even,
	icon,
	carotIcon,
	type,
}) {
	const [answerExpanded, setAnswerExpanded] = useState(false);
	const handleExpandAnswer = useCallback(() => {
		setAnswerExpanded((prev) => !prev);
	}, []);
	return (
		<div className={classnames(className, 'faq-item', even)}>
			<div
				onClick={handleExpandAnswer}
				onKeyDown={handleExpandAnswer}
				role="button"
				tabIndex={0}
				className={classnames(className, 'faq-item-question')}
			>
				{/* <Paragraph size="small" className="question">
					<MarkdownWrapper content={[question]} />
				</Paragraph> */}
				{icon ? (
					<div className="icon-question-wrapper">
						{icon && (
							<img
								src={icon}
								alt=""
							/>
						)}
						<Paragraph
							size="small"
							className="question"
						>
							<MarkdownWrapper
								icon={icon}
								content={[question]}
							/>
						</Paragraph>
					</div>
				) : (
					<MarkdownWrapper content={[question]} />
				)}

				<Button
					primary={false}
					className="extend-button"
					aria-expanded={answerExpanded}
					aria-controls={`faq-answer-${question.replace(/\s+/g, '-').toLowerCase()}`}
					aria-label={
						answerExpanded ? 'Collapse answer' : 'Expand answer'
					}
				>
					<div
						className={carotIcon ? 'carot-icon' : 'plus-minus-icon'}
					>
						{carotIcon ? (
							<ChevronDown reverse={answerExpanded} />
						) : answerExpanded ? (
							<Minus />
						) : (
							<Plus />
						)}
					</div>
				</Button>
			</div>
			<Expand
				showing={answerExpanded}
				preserve
			>
				<div className="faq-item-answer">
					<Text
						last
						className="answer"
					>
						{type === 'facility' ? (
							<FeaturesItem
								featuresData={answer}
								type={type}
							/>
						) : type === 'access&hours' ? (
							<FacilityHours
								accessHours={answer.accessHours}
								officeHours={answer.officeHours}
								showFullDay={true}
							/>
						) : (
							<MarkdownWrapper content={[answer]} />
						)}
					</Text>
				</div>
			</Expand>
		</div>
	);
}

FAQItem.propTypes = {
	className: PropTypes.string,
	question: PropTypes.string.isRequired,
	answer: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.object,
		PropTypes.array,
	]).isRequired,
	even: PropTypes.bool,
	icon: PropTypes.string,
	carotIcon: PropTypes.bool,
	type: PropTypes.string,
};

export default FAQItem;
